import {axios as http} from "@/plugins/http"

export default class Api {
    static categories(startId) {
        let config = {
            params: {
                start_id: startId,
            },
        }

        return http.get("/api/v1/wishlist/category", config).then((resp) => {
            return resp.data["items"]
        })
    }

    static themes(limit) {
        let config = {
            params: {
                limit: limit,
            },
        }

        return http.get("/api/v1/wishlist/themes", config).then((resp) => {
            return resp.data["items"]
        })
    }

    static users(limit) {
        let config = {
            params: {
                limit: limit,
            },
        }

        return http.get("/api/v1/wishlist/users", config).then((resp) => {
            return resp.data["items"]
        })
    }

    static wishlists() {
        let config = {
            params: {},
        }

        return http.get("/api/v1/wishlist/wishlists", config).then((resp) => {
            return resp.data["items"]
        })
    }
}
